import { render, staticRenderFns } from "./InquiryDetailForm.vue?vue&type=template&id=0383fd0f&"
import script from "./InquiryDetailForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryDetailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports